/**
 * Skip Link for keyboard users to bypass navigation
 *
 * @author Claude
 * @a11y Provides keyboard users a way to skip to main content
 */
import { styled } from '@mui/material/styles';
import { Link } from '@mui/material';

// Skip link component for keyboard users
const StyledSkipLink = styled(Link)(({ theme }) => ({
  position: 'absolute',
  left: '-999px',
  width: '1px',
  height: '1px',
  top: 'auto',
  overflow: 'hidden',
  zIndex: theme.zIndex.tooltip + 1,
  
  // When focused, make visible
  '&:focus': {
    left: theme.spacing(2),
    top: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    width: 'auto',
    height: 'auto',
    overflow: 'auto',
    textDecoration: 'none',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[4],
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
}));

/**
 * Skip link component that appears when focused
 * @returns {JSX.Element} Skip link that becomes visible on focus
 * 
 * @a11y Allows keyboard users to bypass repetitive navigation
 * @a11y Should be the first focusable element on the page
 */
export const SkipLink = () => {
  return (
    <StyledSkipLink href="#main-content">
      Skip to main content
    </StyledSkipLink>
  );
};